<script>
  export let src;
  export let alt;
  export let layout;
</script>

<img
  class='{layout}'
  src={src}
  alt={alt} />

<style>
    img {
        vertical-align: middle;
    }
</style>